import OperatorConsole from '@/components/admin/OperatorConsole';
import { ErrorBoundary } from '@/components/ErrorBoundary';

const Admin = () => {
  return (
    <ErrorBoundary>
      <OperatorConsole />
    </ErrorBoundary>
  );
};

export default Admin;
